module.exports = __webpack_public_path__ + "img/Feature.5c7268b2.jpg";